import { createSelector } from 'reselect';
import { KEY } from './';
import { GlobalState } from 'store/types';

const getMediaState = (state: GlobalState) => state[KEY];

const selectAction = createSelector(getMediaState, (state) => state.action);

const selectConfiguration = createSelector(getMediaState, (state) => state.configuration);

const selectUpperDeckMediaType = createSelector(getMediaState, (state) => state.upperDeck.mediaType);

const selectLowerDeckMediaType = createSelector(getMediaState, (state) => state.lowerDeck.mediaType);

const selectEnvironment = createSelector(getMediaState, (state) => state.environment);

const selectEvent = createSelector(getMediaState, (state) => state.event.selected);

const selectVenue = createSelector(getMediaState, (state) => state.venue.selected);

const selectGenre = createSelector(getMediaState, (state) => state.genre.selected);

const selectEventImages = createSelector(getMediaState, (state) => state.event.media);

const selectVenueImages = createSelector(getMediaState, (state) => state.venue.media);

const selectGenreImages = createSelector(getMediaState, (state) => state.genre.media);

const selectUpperDeckImages = createSelector(getMediaState, (state) => state.upperDeck.media);

const selectLowerDeckImages = createSelector(getMediaState, (state) => state.lowerDeck.media);

const selectOtherImages = createSelector(getMediaState, (state) => state.otherImages);

export const selectors = {
  selectAction,
  selectConfiguration,
  selectUpperDeckMediaType,
  selectLowerDeckMediaType,
  selectEnvironment,
  selectEvent,
  selectVenue,
  selectGenre,
  selectEventImages,
  selectVenueImages,
  selectGenreImages,
  selectUpperDeckImages,
  selectLowerDeckImages,
  selectOtherImages
};
